import {} from "./cfg/config";
import {} from "./controller";
import {} from "./controller/IAssetGenerationController";
import { makeConfig } from "stagedConfig";
export class ConfigurationManager {
    _config;
    _baseUrl;
    constructor() {
        this._config = makeConfig();
    }
    static __instance = null;
    static getInstance() {
        if (!ConfigurationManager.__instance) {
            ConfigurationManager.__instance = new ConfigurationManager();
        }
        return ConfigurationManager.__instance;
    }
    get assetGenerationController() {
        return this._config.assetGenerationController;
    }
    get bookingController() {
        return this._config.bookingController;
    }
    get gamesController() {
        return this._config.gamesController;
    }
    get keycloakConfig() {
        return this._config.keycloakConfig;
    }
    get statsController() {
        return this._config.statsController;
    }
}
